import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from "@/screens/Landing";
import ResultPage from "@/screens/Result";
import RoomPage from "@/screens/Room";
import CampingClubPage from "@/screens/CampingClub";
import CartPage from "@/screens/Cart";
import WeTalkAboutUsPage from "@/screens/WeTalkAboutUs";
import BlogPage from "@/screens/Blog";
import ArticlePage from "@/screens/Article";
import FAQPage from "@/screens/FAQ";
import Page from "@/screens/Page";
import FeedbackPage from "@/screens/Feedback";
import OfferPage from "@/screens/Offer";
import ContactUsPage from "@/screens/ContactUs";
import PromotionPage from "@/screens/Promotion";
import Error404Page from "@/screens/Error404";
import Error500Page from "@/screens/Error500";

const routes = [
  { path: "", component: LandingPage, meta: { layout: "default" } },
  { path: "/result", component: ResultPage, meta: { layout: "default" } },
  { path: "/cart", component: CartPage, meta: { layout: "default" } },

  {
    path: "/ventes-flash",
    component: PromotionPage,
    meta: { layout: "default" }
  },
  {
    path: "/page/:slug",
    component: Page,
    meta: { layout: "default" }
  },
  // we talk about us
  {
    path: "/we-talk-about-us",
    component: WeTalkAboutUsPage,
    meta: { layout: "default" }
  },
  {
    path: "/on-parle-de-nous",
    component: WeTalkAboutUsPage,
    meta: { layout: "default" }
  },
  // end we talk about us
  { path: "/blog", component: BlogPage, meta: { layout: "default" } },
  { path: "/blog/:id", component: ArticlePage, meta: { layout: "default" } },
  { path: "/faq", component: FAQPage, meta: { layout: "default" } },
  {
    path: "/comments/:reference_id/:reservation_id",
    component: FeedbackPage,
    meta: { layout: "default" }
  },
  {
    path: "/contact-us",
    component: ContactUsPage,
    meta: { layout: "default" }
  },
  // offer
  {
    path: "/offer",
    component: OfferPage,
    meta: { layout: "default" }
  },
  {
    path: "/offres-demplois/",
    component: OfferPage,
    meta: { layout: "default" }
  },
  // end offer
  {
    path: "/room/:id",
    component: RoomPage,
    meta: { layout: "default" }
  },
  {
    path: "/camping/:id",
    component: CampingClubPage,
    meta: { layout: "default" }
  },
  {
    path: "/400",
    component: Error404Page,
    meta: { layout: "default" }
  },
  { path: "*", component: Error404Page },
  {
    path: "/500",
    component: Error500Page,
    meta: { layout: "default" }
  }
];
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes
});
export default router;
